import { Modal, Button, Typography, Box } from '@mui/material';
import { useState } from 'react';

interface EditCustomerDialogProps {
  isOpen: boolean;
  onDialogDecision: (result: boolean) => void;
  currentCustomer: string;
  newAbgMasterName: string;
  brand: string;
  customerAlreadyExists: boolean;
  isRejection: boolean;
}

export default function EditCustomerConfirmation({
  isOpen,
  onDialogDecision,
  currentCustomer,
  newAbgMasterName,
  brand,
  customerAlreadyExists,
  isRejection,
}: EditCustomerDialogProps) {
  const [open, setOpen] = useState(isOpen);

  const handleDecision = (result: boolean) => {
    onDialogDecision(result); // Pass the result to the parent and wait for resolution
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      aria-labelledby='edit-customer-confirmation'
      aria-describedby='confirmation-of-name-change'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography id='alert-dialog-description' sx={{ mt: 2 }}>
          {isRejection
            ? `Are you sure you want to reject the name change for ${currentCustomer} to ${newAbgMasterName}`
            : customerAlreadyExists
            ? `Contracts for this customer already exist in ${brand}. Do you want to transfer this contract from ${currentCustomer} to the ${newAbgMasterName} customer?`
            : `By clicking Agree, you will transfer all contracts for ${currentCustomer} to the ${newAbgMasterName} customer.`}
        </Typography>
        {!isRejection && (
          <Typography id='alert-dialog-description' sx={{ mt: 2 }}>
            {`Performing this action will delete ${currentCustomer}.`}
          </Typography>
        )}
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => handleDecision(false)} color='primary' variant='outlined' sx={{ mr: 2 }}>
            Disagree
          </Button>
          <Button onClick={() => handleDecision(true)} color='primary' variant='contained'>
            Agree
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
